import React from 'react'

const YoungWoman: React.FC = () => {
	return (
		<div className='timeline--young-woman timeline-section'>
			<div className='timeline--young-woman__event'>
				<div className='young-woman--gallery'>
					<img src='/images/timeline/young-woman.png' alt='Mummy Lillian as a young woman' />
					<img src='/images/timeline/portrait.png' alt='Portrait of Mummy Lillian' />
				</div>

				<div className='young-woman--content'>
					<h5>A young woman</h5>
					<p>Then the making of an everlasting woman began. She found strength on her knees.</p>
					{/* <svg width='216' height='33' viewBox='0 0 216 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M3.99994 8.46405C38.9533 6.15486 28.4479 7.48704 51.2669 5.18349C74.086 2.87993 320.139 4.00081 134.286 8.6802C-51.5679 13.3596 178.35 15.722 198.214 23.4189C202.829 25.2069 207.446 27.5079 212.206 29.0453'
							stroke='#DF5A33'
							strokeWidth='6.36225'
							strokeLinecap='round'
						/>
					</svg> */}
				</div>
			</div>
		</div>
	)
}

export default YoungWoman
